import { useEffect, useState } from 'react';

import { useSetup2FA } from './hooks/useSetupMFA';
import { useConfirm2FA } from './hooks/useConfirmMFA';
import MultiFactorAuthenticatorModal from './MultiFactorAuthenticatorModal';
import { RecoveryCodeModal } from './RecoveryCodeModal';


const RELOAD_DELAY_MS = 100;

type AuthenticatorModalProps = {
    logout?: () => void;
    isVerifyMode?: boolean;
};

/**
 * 多要素認証モーダルコンポーネント
 * ユーザーの2要素認証設定を管理するモーダル
 */
export const AuthenticatorModal = ({
    logout,
    isVerifyMode = false,
}: AuthenticatorModalProps) => {
    const [isMFAOpen, setIsMFAOpen] = useState(false);
    const [isRecoveryCodeOpen, setIsRecoveryCodeOpen] = useState(false);
    const [setUpData] = useSetup2FA();
    const [confirmData, requestConfirm2FA] = useConfirm2FA();

    // 2FAセットアップ完了後にMFA登録モーダルを開く
    useEffect(() => {
        if (setUpData.loading) return;
        if (!setUpData.data) return;
        
        setIsMFAOpen(true);
    }, [setUpData]);

    // 2FA確認完了後にMFAモーダルを閉じ、リカバリーコードモーダルを開く
    useEffect(() => {
        if (confirmData.loading) return;
        if (!confirmData.data) return;

        setIsMFAOpen(false);
        setIsRecoveryCodeOpen(true);
    }, [confirmData]);

    /** MFA登録モーダルを閉じるハンドラ */
    const onMFAClose = () => {
        setIsMFAOpen(false);
    };

    /** リカバリーコードモーダルを閉じてページをリロード（または / へリダイレクト）するハンドラ */
    const onRecoveryClose = () => {
        setIsRecoveryCodeOpen(false);
        setTimeout(() => {
            if (isVerifyMode) {
                window.location.replace('/')
            } else {
                window.location.reload();
            }
        }, RELOAD_DELAY_MS);
    };

    return (
        <div className='authenticator'>
            <MultiFactorAuthenticatorModal
                handleClose={onMFAClose}
                isOpen={isMFAOpen}
                setUpData={setUpData.data}
                requestConfirm2FA={requestConfirm2FA}
                isVerifyMode={isVerifyMode}
                logout={logout}
                serverErrorMessage={confirmData.errorMessage}
            />

            <RecoveryCodeModal 
                isOpen={isRecoveryCodeOpen}
                handleClose={onRecoveryClose}
            />
        </div>
    );
};
